import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import ProfilePictureWithIndicators from "../../Presentational/ProfilePictureWithIndicators/ProfilePictureWithIndicators";
import ProfilePicture from "../../Presentational/Person/ProfilePicture/ProfilePicture";
import { getMessageInboxDetailPath, getMessageSentDetailPath, } from "../../Pages/Message/MessageRoutes/MessageRoutes";
import FAIcon from "../../UI/FAIcon/FAIcon";
const MessageListItem = (props) => {
    const { message, hasPermissionForCourseSuccessScore, hasPermissionForTermSuccessScore, sent = false, } = props;
    const location = useLocation();
    if (!message) {
        return null;
    }
    const { from, to, fromFullName, toFullName, subject, sanitizedSubject, isSms, read, createdDate, hasSuccessfulDelivery, errorMessage, threadId, body, } = message;
    /**
     * Based on whether we are displaying inbox or sent messages we will set the person appropriately
     * */
    const person = sent ? to : from;
    const getClassNameForFullName = () => {
        if (sent) {
            return "";
        }
        return !read ? "font-weight-bold" : "";
    };
    const renderIcon = () => {
        let spanIcon;
        // SENT
        if (sent) {
            if (isSms && hasSuccessfulDelivery) {
                // SMS & DELIVERED
                spanIcon = (_jsxs("span", { title: "Text message thread", children: [_jsx(FAIcon, { icon: "mobile-alt", type: "fas" }), _jsx("span", { className: "sr-only", children: "Delivered by text message" })] }));
            }
            else if (!isSms && hasSuccessfulDelivery) {
                // EMAIL & DELIVERED
                spanIcon = (_jsxs("span", { title: "Delivered by email", children: [_jsx(FAIcon, { icon: "envelope" }), _jsx("span", { className: "sr-only", children: "Delivered by email" })] }));
            }
            else if (!hasSuccessfulDelivery && errorMessage) {
                // NOT DELIVERED
                spanIcon = (_jsxs("span", { title: `Undeliverable - ${errorMessage}`, className: "mr-1 text-danger", children: [_jsx(FAIcon, { icon: "exclamation-triangle", type: "fa" }), _jsx("span", { className: "sr-only", children: "Undeliverable" })] }));
            }
            else {
                spanIcon = "";
            }
        }
        else if (isSms) {
            // RECEIVED
            // SMS
            spanIcon = (_jsxs("span", { title: "Delivered by text message", children: [_jsx(FAIcon, { icon: "mobile-alt", type: "fas" }), _jsx("span", { className: "sr-only", children: "Delivered by text message" })] }));
        }
        else {
            // EMAIL
            spanIcon = (_jsxs("span", { title: "Delivered by email", children: [_jsx(FAIcon, { icon: "envelope" }), _jsx("span", { className: "sr-only", children: "Delivered by email" })] }));
        }
        return _jsx("span", { className: "text-right", children: spanIcon });
    };
    const isActive = location.pathname.includes(message.threadId) ? "active" : "";
    return (_jsx(Link, { to: {
            pathname: sent
                ? getMessageSentDetailPath(threadId)
                : getMessageInboxDetailPath({ threadId }),
            search: location.search,
        }, className: `list-group-item list-group-item-action clickable flex-column align-items-stretch text-dark px-2 bg-light ${isActive}`, style: {
            textDecoration: "none",
            height: "84px",
            border: "none",
            margin: "0",
        }, children: _jsxs("div", { className: "media", children: [_jsx(ProfilePictureWithIndicators, { profilePicture: _jsx(ProfilePicture, { person: person, showProfilePicture: true }), showIndicators: hasPermissionForCourseSuccessScore ||
                        hasPermissionForTermSuccessScore, hasPermissionForTermSuccessScore: hasPermissionForTermSuccessScore, hasPermissionForCourseSuccessScore: hasPermissionForCourseSuccessScore, courseSuccessScore: hasPermissionForCourseSuccessScore
                        ? person.transcriptSuccessScoringGroup
                        : null, termSuccessScore: hasPermissionForTermSuccessScore ? person.successScoringGroup : null }), _jsxs("div", { className: "media-body", children: [_jsxs("div", { className: "d-flex justify-content-between", children: [_jsx("div", { className: "d-flex align-items-baseline", children: _jsx("div", { className: `m-0 ${getClassNameForFullName()}`, children: sent ? toFullName : fromFullName }) }), renderIcon()] }), _jsx("div", { children: _jsx("small", { className: isActive ? "text-dark" : "text-muted", children: createdDate }) }), !isSms ? (_jsx("div", { className: "message-item", children: _jsx("div", { className: "text-truncate", 
                                /* eslint-disable-next-line react/no-danger */
                                dangerouslySetInnerHTML: { __html: sanitizedSubject || "" }, title: sanitizedSubject }) })) : (_jsx("div", { className: "message-item", children: _jsx("div", { className: "text-truncate", title: body, children: body }) }))] })] }) }));
};
export default MessageListItem;
